<template>
  <div class="d-inline-block">
    <div>
      <b-modal ref="verification-data-modal" hide-footer>
        <div slot="modal-title" v-html="addressVerificationStatus" />
        <pre class="my-4 verification-data">{{ addressVerificationData }}</pre>
      </b-modal>
    </div>
    <b-dropdown
      v-if="flags.debugTools"
      size="lg"
      variant="link"
      toggle-class="text-decoration-none"
      no-caret
      class="icon-button"
    >
      <template slot="button-content"><span v-html="getIcon"></span></template>
      <b-dropdown-item href="#" v-html="addressVerificationStatus" @click="showVerificationData" />
      <b-dropdown-item href="#" v-if="!addressVerification" @click="verifyAddress">Verify</b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { putVerifyAddress } from "@/services/addresses"

  export default {
    props: {
      address: { type: Object, required: true },
      addressType: { type: String, required: false },
      onVerificationFinish: { type: Function, required: true },
    },
    data() {
      return {
        isBusy: false,
      }
    },
    computed: {
      ...mapGetters(["flags"]),
      addressVerification() {
        return this.address && this.address.address_verification;
      },
      addressVerificationData() {
        if (this.addressVerification) {
          return JSON.stringify(this.addressVerification.verification_data, null, 2)
        }
      },
      addressVerificationStatus() {
        if (this.addressVerification) {
          if (this.addressVerification.is_valid) {
            return '<span class="popover-heading-valid">Valid</span>'
          }
          return '<span class="popover-heading-invalid">Invalid</span>'
        }
        return 'Unvalidated'
      },
      getAddressType() {
        return this.addressType ? this.addressType : this.address.type;
      },
      getIcon() {
        const iconStatic = '<i class="fas fa-cog light-blue"></i>';
        const iconDynamic = '<i class="fas fa-cog fa-spin light-blue"></i>'
        return this.isBusy ? iconDynamic : iconStatic
      }
    },
    methods: {
      showVerificationData() {
        if (this.addressVerification) {
          this.$refs['verification-data-modal'].show();
        }
      },
      async verifyAddress() {
        this.isBusy = true;
        await putVerifyAddress(this.address.id, this.getAddressType);
        this.onVerificationFinish();
        this.isBusy = false;
      }
    },
  }
</script>

<style lang="scss">

  @import '~scss/colors.scss';

  i.fas.light-blue {
    color: $light-blue;
  }

  pre.verification-data {
    font-size: 14px;
    text-align: left;
  }

  .icon-button button {
    font-size: 1em;
    line-height: 1.5;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/AddressVerification.vue